import { render, staticRenderFns } from "./ThemeTranslation.vue?vue&type=template&id=0d3fb392&scoped=true&"
import script from "./ThemeTranslation.vue?vue&type=script&lang=js&"
export * from "./ThemeTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3fb392",
  null
  
)

export default component.exports